// import logo from "./logo.svg";
// import "./App.css";
import { Button } from "./components/Button";
import { Container } from "./components/Container";
import { CTAOne } from "./components/cta/CtaOne";
import { FAQOne } from "./components/faq/FAQOne";
import { FeaturesOne } from "./components/features/FeaturesOne";
import { FeaturesOneWithImage } from "./components/features/FeaturesOneWithImage";
import { FeaturesTwoWithImage } from "./components/features/FeaturesTwoWithImage";
import { Header } from "./components/header/Header";
import { HeaderTwo } from "./components/header/HeaderTwo";
import { Hero } from "./components/hero/Hero";
import HeroThree from "./components/hero/HeroThree";
import HeroTwo from "./components/hero/HeroTwo";
import { PricingOne } from "./components/pricing/PricingOne";
import { TestimonialOne } from "./components/testimonials/TestimonialOne";
import { TestimonialTwo } from "./components/testimonials/TestimonialTwo";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Main from "./pages/Main";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Stock from "./pages/Stock";
import RealEstate from "./pages/RealEstate";
import Crypto from "./pages/Crypto";
import Forex from "./pages/Forex";
import Why from "./pages/Why";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import DefaultPage from "./pages/404";
import Legal from "./pages/Legal";
import { toast, Toaster } from "sonner";
import { useEffect } from "react";
import { countries } from "./static";
import { formatterZero } from "./utils/utils";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Main />,
    },
    {
      path: "/about",
      element: <About />,
    },
    {
      path: "/faq",
      element: <FAQ />,
    },
    {
      path: "/stocks",
      element: <Stock />,
    },
    {
      path: "/crypto",
      element: <Crypto />,
    },
    {
      path: "/forex",
      element: <Forex />,
    },
    // {
    //   path: "/realestate",
    //   element: <RealEstate />,
    // },
    {
      path: "/why-us",
      element: <Why />,
    },
    {
      path: "/privacy",
      element: <Privacy />,
    },
    {
      path: "/legal",
      element: <Legal />,
    },
    {
      path: "/terms",
      element: <Terms />,
    },
    {
      path: "*",
      element: <DefaultPage />,
    },
  ]);

  function generateRandomInterval() {
    return (Math.floor(Math.random() * 8) + 5) * 1000;
  }

  function generateRandomAmount() {
    return Math.floor(Math.random() * 10000) + 1000;
  }

  function generateRandomCountry() {
    return countries[Math.floor(Math.random() * countries.length)];
  }

  useEffect(() => {
    const toastInterval = setInterval(() => {
      const country = generateRandomCountry();
      toast.success(
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
            zIndex: "9999999",
          }}
        >
          <img
            loading="lazy"
            width="16"
            src={`https://flagcdn.com/w20/${country.code.toLowerCase()}.png`}
            srcSet={`https://flagcdn.com/w40/${country.code.toLowerCase()}.png 2x`}
            alt={`Flag of ${country.label}`}
          />
          A user from {country.label} has just{" "}
          {Math.random() > 0.5 ? "deposited" : "withdrawn"}{" "}
          {formatterZero.format(generateRandomAmount())}
        </div>
      );
    }, generateRandomInterval());

    return () => clearInterval(toastInterval);
  }, []);

  return (
    <>
      <RouterProvider router={router} />
      <Toaster position="bottom-left" />
    </>
  );
}

{
  /* <div style={{ backgroundColor: "#05080b" }}>
<Header />
</div>
<HeaderTwo />
<HeroThree />
<div style={{ backgroundColor: "#05080b" }}>
<Hero />
</div>
<FeaturesTwoWithImage />
<TestimonialOne />
<FAQOne />
<TestimonialTwo />
<PricingOne />
<CTAOne />
<FeaturesOne />
<FeaturesOneWithImage />
<TestimonialTwo /> */
}

export default App;
